import { useLanguage } from '@/hooks/useLanguage';
import { Layout } from '@/components/layout/Layout';
import { SEOHead } from '@/components/SEOHead';
import { OrganizationSchema, WebsiteSchema } from '@/components/StructuredData';
import { HeroSection } from '@/components/home/HeroSection';
import { WhatIsSection } from '@/components/home/WhatIsSection';
import { FourPathsSection } from '@/components/home/FourPathsSection';
import { HowToUseSection } from '@/components/home/HowToUseSection';
import { StartHereSection } from '@/components/home/StartHereSection';
import { AboutSection } from '@/components/home/AboutSection';
import { ToolkitSection } from '@/components/home/ToolkitSection';
import { WorkbooksSection } from '@/components/home/WorkbooksSection';
import { DecisionJourney } from '@/components/workbooks/DecisionJourney';

import { MagazineGrid } from '@/components/editorial/MagazineGrid';
import { EditorialDivider } from '@/components/editorial/EditorialDivider';
import { Eyebrow } from '@/components/editorial/Eyebrow';
import { getLatestArticles } from '@/data/articleIndex';

const Home = () => {
  const { t } = useLanguage();
  const featured = getLatestArticles(6);

  return (
    <Layout>
      <SEOHead
        title="Alternative Living & Off-Grid Lifestyle"
        description="Discover the art of alternative living — from vans and tiny homes to boats and off-grid cabins. Personal insights, honest tips, and inspiration."
        path=""
      />
      <OrganizationSchema />
      <WebsiteSchema />

      <HeroSection />

      <WhatIsSection />

      <div className="container mx-auto px-6">
        <EditorialDivider variant="chapter" chapter="Chapter I" />
      </div>

      <FourPathsSection />

      <div className="container mx-auto px-6">
        <EditorialDivider variant="chapter" chapter="Chapter II" />
      </div>

      <HowToUseSection />

      <StartHereSection />

      <div className="container mx-auto px-6">
        <EditorialDivider variant="diamond" />
      </div>

      <ToolkitSection />

      <div className="container mx-auto px-6">
        <EditorialDivider variant="chapter" chapter="Chapter III" />
      </div>

      {/* Latest articles — magazine grid */}
      <section className="py-20 md:py-28">
        <div className="container mx-auto px-6 md:px-8">
          <header className="text-center mb-16">
            <Eyebrow variant="rules" align="center" as="div" className="mb-6">
              The Dispatch
            </Eyebrow>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium text-primary tracking-tight leading-[1.05]">
              {t('home.latestArticles')}
            </h2>
          </header>
          <MagazineGrid articles={featured} />
        </div>
      </section>

      <div className="container mx-auto px-6">
        <EditorialDivider variant="diamond" />
      </div>

      <WorkbooksSection />

      <section className="pb-20 md:pb-28">
        <div className="container mx-auto px-6 md:px-8">
          <DecisionJourney className="max-w-4xl mx-auto" />
        </div>
      </section>

      <div className="container mx-auto px-6">
        <EditorialDivider variant="diamond" />
      </div>

      <AboutSection />

    </Layout>
  );
};

export default Home;
